import { makeActionCreator } from '../../config/store/utils'
import theme from '../../config/styles/theme'
import { getBuyersSize } from '../../services/buyers'

export const GET_BUYERS_PROVIDERS_SIZE = 'GET_BUYERS_PROVIDERS_SIZE'
export const GET_BUYERS_PROVIDERS_SIZE_ERROR = 'GET_BUYERS_PROVIDERS_SIZE_ERROR'
export const GET_BUYERS_PROVIDERS_SIZE_SUCCESS = 'GET_BUYERS_PROVIDERS_SIZE_SUCCESS'
export const onGetBuyersProvidersSize = makeActionCreator(GET_BUYERS_PROVIDERS_SIZE)
export const onGetBuyersProvidersSizeError = makeActionCreator(GET_BUYERS_PROVIDERS_SIZE_ERROR, 'payload')
export const onGetBuyersProvidersSizeSuccess = makeActionCreator(GET_BUYERS_PROVIDERS_SIZE_SUCCESS, 'payload')
export const onGetBuyersProvidersSizeThunk = payload => async dispatch => {
  dispatch(onGetBuyersProvidersSize())

  try {
    const { data } = await getBuyersSize({ sectorId: payload.sectorId, year: payload.year })
    const enhancedData = data.payload.map(item => {
      // FIXME: Gets color name from a fixed source.
      const colorName = Object.keys(theme.palette.charts)[window.Math.floor(window.Math.random() * 30)]

      return {
        amount: item.amountCLP,
        amountUSD: item.amountUSD,
        color: theme.palette.charts[colorName],
        name: item.size,
        sector: item.sector,
        percentage: item.percentageCLP
      }
    })
    const csv = [
      ['Año', 'Tamaño de proveedor', 'Sector del estado', 'Monto transado', 'Monto transado (USD)'],
      ...enhancedData.map(item => [payload.year, item.name, item.sector, item.amount, item.amountUSD])
    ]

    return dispatch(onGetBuyersProvidersSizeSuccess({ csv, data: enhancedData }))
  } catch (error) {
    return dispatch(onGetBuyersProvidersSizeError({ error }))
  }
}
